export const TOKEN_COOKIES = 'phToken'
export const USER_ID_COOKIES = 'phUserId'
export const REGISTRATION_CHOSEN_SUBSCRIPTION_TYPE = 'registrationChosenSubscriptionType'